module.exports = __webpack_public_path__ + "public/img/车辆布控Bg.75a5ce54.png";